import { ordersService, useToast, CloseCircleOutline } from '@aslanpay/portal-common-lib';
import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import { OrderArchiveModalProps } from './types';

function OrderArchiveModal({ isOpen, onClose, orderId }: OrderArchiveModalProps) {
  const toast = useToast();
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    onClose();
  };

  const handleArchive = async () => {
    setIsLoading(true);
    try {
      await ordersService.archiveOrder(orderId);
      await queryClient.invalidateQueries(['fetchOrdersPage']);
      toast({
        position: 'top-right',
        title: 'Order archived',
        status: 'success',
        description: 'This order has been archived successfully.',
      });
      onClose();
    } catch (error) {
      toast({
        position: 'top-right',
        title: 'Failed to archive order',
        status: 'error',
        description: 'An error occurred while archiving this order. Please try again.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      onClose={handleClose}
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack>
            <Text as="h6">Archive order?</Text>
          </HStack>
        </ModalHeader>
        <ModalBody>
          <Text mb="16px">Please confirm if you want to archive this order.</Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" onClick={handleClose} size="sm">
            Cancel
          </Button>
          <Button
            onClick={handleArchive}
            size="sm"
            isLoading={isLoading}
            color="white"
            bg="system.error"
            leftIcon={<CloseCircleOutline boxSize="20px" />}
          >
            Yes, archive
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default OrderArchiveModal;
